import type { ReactNode } from 'react';

import { OidcSessionProvider } from './OidcSessionProvider';
import { TestLoginSessionProvider } from './testLogin/TestLoginSessionProvider';

import { config } from '@/config';

/**
 * Chooses the authentication backend once, at the root. The choice is made from
 * static config rather than per-render state, so no component below ever sees a
 * provider swap underneath it.
 */
export const SessionProvider = ({ children }: { children: ReactNode }) =>
  config.testLoginEnabled ? (
    <TestLoginSessionProvider>{children}</TestLoginSessionProvider>
  ) : (
    <OidcSessionProvider>{children}</OidcSessionProvider>
  );
